// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".currency .el-input__inner{padding-right:2.083vw!important}.currency .infoShow{width:100%;height:100%;border:0;color:#555;font-size:.729vw}", ""]);
// Exports
module.exports = exports;
